import type { ChangeEvent } from 'react';
import styles from './NutrientInput.module.css';

export interface NutrientInputProps {
	value: string;
	suffix: string;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
	placeholder?: string;
	disabled?: boolean;
	hasError?: boolean;
}

export const NutrientInput = ({
	value,
	suffix,
	onChange,
	placeholder = '0',
	disabled,
	hasError,
}: NutrientInputProps) => (
	<div className={`${styles.wrapper} ${value ? styles.hasValue : ''} ${hasError ? styles.error : ''}`}>
		<input
			type="number"
			value={value}
			onChange={onChange}
			placeholder={placeholder}
			disabled={disabled}
			className={styles.input}
		/>
		<div className={styles.divider} />
		<span className={styles.suffix}>{suffix}</span>
	</div>
);
